module.exports = __webpack_public_path__ + "static/media/zto-express.48d7e12f.svg";